import { render, staticRenderFns } from "./system.vue?vue&type=template&id=2231c5c0&"
import script from "./system.vue?vue&type=script&lang=js&"
export * from "./system.vue?vue&type=script&lang=js&"
import style0 from "./system.vue?vue&type=style&index=0&id=2231c5c0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports